import {getApiMetadataWithoutToken} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {SearchRepositoriesResponse} from './contracts'

export async function apiSearchRepositories(query: string): Promise<SearchRepositoriesResponse> {
  const apiData = getApiMetadataWithoutToken('search-repositories-api-data')
  const url = new URL(apiData.url, window.location.origin)
  url.searchParams.set('q', query)
  const {data} = await fetchJSON<SearchRepositoriesResponse>(url)

  return data
}
